<template>
	<div class="chat-window" :style="dynStyles" spacing="20" data-ukey="">
		<div @click="modalClickTrap" :class="['click-trap', {'modal-opened': clickTrapActive}]"></div>

		<audio ref="notificationSound" class="chat-audio-notification">
			<source src="/assets/audio/notification.mp3">
		</audio>

		<div :class="['flex-none', 'c-flex-rows', 'menu', {'menu-hidden': !menuVisibility}]">
			<div class="title flex-none c-flex-cols c-flex-align-center">
				<div class="flex-auto c-flex-cols c-flex-align-center" style="overflow: hidden;">
					<svg-icon
						:class="['flex-none', 'star', state.connected ? 'status-online' : 'status-away']"
						name="star0"
						:title="state.connected ? 'Подключено' : 'Соединение...'"
					/>
					<div class="flex-auto" style="overflow: hidden;">
						<span class="user-login" v-text="userLogin" :title="userLogin"/>
					</div>
				</div>
				<img
					@click="showSettings"
					src="/assets/i/settings.svg"
					class="chat-button flex-none"
					title="Настройки приложения">
			</div>

			<div class="rooms-list">
				<RoomsList @scrollToEnd="$refs.messagesBox.scrollToEnd()"/>
			</div>

			<div @click="joinRoom" class="chat-button-join-room flex-none" title="Подключиться к комнате"/>

			<div class="tool-buttons flex-none c-flex-cols">
				<img @click="createRoom" src="/assets/i/chat_add.svg" class="chat-button" title="Создать новую комнату">
				<img @click="removeRoom" src="/assets/i/chat_delete.svg" class="chat-button" title="Удалить текущую комнату">
			</div>
		</div>

		<div class="main">
			<div class="chat-rooms-block flex-none c-flex-cols c-flex-align-center">
				<img
					@click="showMenu"
					class="chat-button chat-button-menu"
					title="Меню"
					src="/assets/i/menu.svg">

				<div class="flex-auto">{{ state.activeTab }}</div>

				<img
					@click="showOnlineList"
					class="chat-button flex-none"
					title="Список онлайна"
					src="/assets/i/userlist.svg">
			</div>

			<div class="chat-messages-area" v-show="state.currentPanel == 'chat'">
				<MessagesBox ref="messagesBox"/>

				<div class="chat-online-box" v-show="onlineListVisibility">
					<OnlineList/>
				</div>
			</div>

			<SettingsForm class="flex-auto chat-settings" v-show="state.currentPanel == 'settings'"/>
		</div>
	</div>
</template>

<script>
import RoomsList from './components/RoomsList.vue';
import MessagesBox from './components/MessagesBox.vue';
import OnlineList from './components/OnlineList.vue';
import SettingsForm from './components/SettingsForm.vue';
import SvgIcon from './components/SvgIcon';
import eventBus from './eventbus';

export default {
	components: {
		RoomsList,
		MessagesBox,
		OnlineList,
		SettingsForm,
		SvgIcon,
	},

	data() {
		return {
			state: eventBus.state,
			menuVisibility: false,
			onlineListVisibility: true,
			clickTrapActive: true,
			heightFix: false,
		};
	},

	computed: {
		userLogin() {
			return this.state.currentUser.id === 0 ? 'Гость' : this.state.currentUser.login;
		},

		dynStyles() {
			return this.heightFix && {'height': `${this.heightFix}px`};
		},
	},

	beforeMount(){
		if (window.innerWidth < 768){
			this.modalClickTrap();
		}
	},

	mounted() {
		let html = document.querySelector('html');
		if (html.clientHeight < html.scrollHeight) {
			this.heightFix = html.clientHeight;
		}
	},

	methods: {
		modalClickTrap(){
			this.menuVisibility = false;
			this.onlineListVisibility = false;
			this.clickTrapActive = false;
		},

		showMenu(){
			this.menuVisibility = !this.menuVisibility;
			this.clickTrapActive = true;
		},

		showSettings(){
			this.state.currentPanel = 'settings';
			this.menuVisibility = false;
			this.clickTrapActive = false;
		},

		showOnlineList(){
			this.onlineListVisibility = !this.onlineListVisibility;
			this.clickTrapActive = true;
		},

		joinRoom(){
			let target = prompt('Введите имя комнаты:');

			if (target == null){
				return;
			}

			if (target[0] != '#'){
				target = '#' + target;
			}

			eventBus.$emit('joinRoom', target);
		},

		createRoom(){
			let name = prompt('Введите имя комнаты: ');

			if (name == null){
				return;
			}

			if (name[0] != '#'){
				name = '#' + name;
			}

			eventBus.$emit('createRoom', name);
		},

		removeRoom(){
			if (confirm('Вы действительно хотите удалить текущую комнату?')){
				eventBus.$emit('removeCurrentRoom');
			}
		},
	},
};
</script>

<style lang="less" scoped>
@import (reference) "~@/css/chat.less";

.chat-window {
	background-color: @color-chat-1;
	box-sizing: border-box;

	display: flex;
	flex-flow: row;

	width: 100%;
	height: 100vh;

	&.mobile-navbar-fix {
		height: calc(100vh - 56px);
	}

	.chat-button {
		height: 24px;
		cursor: pointer;
	}
}

.click-trap {
	display: none;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 100;
	width: 100vw;
	height: 100vh;
}

@media all and (max-width: @mobile-width - 1){
	.click-trap.modal-opened {
		display: block;
	}
}

.menu {
	width: 230px;
	background-color: @color-chat-3;

	> .title {
		padding: 8px;
		border-bottom: 2px solid @color-chat-1;
	}
}

.chat-button-menu {
	margin-right: 10px;
}

@media all and (min-width: @mobile-width){
	.chat-button-menu {
		display: none;
	}
}

@media all and (max-width: @mobile-width - 1){
	.menu.menu-hidden {
		display: none;
	}

	.menu {
		position: absolute;
		z-index: 200;
		height: 100vh;
	}
}

.rooms-list {
	padding: 5px;
	overflow-x: hidden;
	overflow-y: auto;
	flex: 0 1 auto;
}

.main {
	flex: auto;
	display: flex;
	flex-flow: column;
	overflow: hidden;
}

.chat-messages-area {
	flex: auto;
	overflow-y: hidden;

	display: flex;
	flex-flow: row;

	> div {
		display: flex;
		flex-flow: column;
		flex: auto;
		overflow: hidden;
	}

	.chat-online-box {
		box-sizing: border-box;
		padding: 10px;
		background-color: @color-chat-3;
		width: 170px;

		@media all and (min-width: @mobile-width){
			flex: none;
		}

		@media all and (max-width: @mobile-width - 1){
			position: absolute;
			right: 0;
			top: 0;
			height: 100vh;
			width: 230px;
			z-index: 200;
		}
	}
}

.chat-rooms-block {
	padding: 8px;
	background-color: @color-chat-4;
	border-bottom: 2px solid @color-chat-1;
}

.chat-button-join-room {
	display: block;
	text-align: center;
	cursor: pointer;
	height: 32px;
	background: url('/assets/i/add.png') no-repeat 50% 50% ~"/" 14px;

	&:hover {
		background-color: @color-chat-5;
		border-radius: 2px;
	}
}

.tool-buttons {
	background-color: @color-chat-4;
	padding: 10px;
	justify-content: center;
	margin-top: auto;

	> * {
		margin: 0 20px;
	}
}

.chat-settings {
	overflow-y: auto;
}

.user-login {
	overflow-x: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: inline-block;
	max-width: 100%;
}

span.star {
	display: inline-block;
	text-align: center;
	vertical-align: middle;
	width: 20px;
	height: 20px;
	margin-right: 5px;

	fill: @color-chat-3;

	&.status-online {
		fill: #3f0;
	}

	&.status-away {
		animation: 0.75s ease anim-connectig alternate infinite;
	}
}

@keyframes anim-connectig {
	0% { fill: @color-chat-3; }
	100% { fill: #fb0; }
}

</style>
